import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { logger } from '@/utils/logger';

export async function getIdToken(): Promise<string> {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error('No ID token available — user is not authenticated');
  }
  return token;
}

export async function getUserOrg(): Promise<string> {
  const session = await fetchAuthSession();
  const claims = session.tokens?.idToken?.payload;
  if (!claims) {
    throw new Error('No ID token claims available');
  }

  const orgId =
    (claims['custom:organizationId'] as string | undefined) ??
    (claims['custom:org'] as string | undefined);

  if (!orgId) {
    throw new Error('Organization ID not found in token claims');
  }

  return orgId;
}

type SignOutListener = () => void;
const listeners: SignOutListener[] = [];

export function onSignOut(listener: SignOutListener): () => void {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx !== -1) listeners.splice(idx, 1);
  };
}

export async function signOutUser(): Promise<void> {
  logger.info('Signing out user');
  for (const listener of listeners) {
    listener();
  }
  await signOut();
}
